module.exports = __webpack_public_path__ + "img/Produktbeispiel_5.401b7e2a.jpg";